import PropTypes from 'prop-types';
import React from 'react';

import { Container, Content, Title } from './styles';

const Card = ({ title, content, children }) => (
  <Container>
    {title && <Title>{title}</Title>}
    {content && <Content>{content}</Content>}
    {children}
  </Container>
);

export default Card;

Card.propTypes = {
  title: PropTypes.string,
  content: PropTypes.node,
  children: PropTypes.node,
};

Card.defaultProps = {
  title: '',
  content: null,
  children: null,
};
